export default function Notes({ notes }) {
  return (
    <>
      <section className="mt-10 mb-5">
        {notes && (
          <>
            <h3 className="text-bold">Additional notes</h3>
            {notes.split(',').map((note,index)=>(
              <p key={index} className="font-thin text-sm text-justify">{note}</p>
            ))}
            
          </>
        )}
      </section>
    </>
  );
}
